import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IonButton, IonList, IonText } from '@ionic/react';
import { PageLayout } from 'containers/layout';
import { AuthSelectors } from 'redux/AuthRedux';
import AppActions, { AppSelectors } from 'redux/AppRedux';
import PayActions from 'redux/PayRedux';
import api_v2 from 'services/api_v2';

function InviteAcceptPage() {
  const [loading, setLoading] = useState(false);
  const { venueId, ticketId } = useParams();
  const dispatch = useDispatch();
  const token = useSelector(AuthSelectors.selectToken);
  const inviteVenue = useSelector(AppSelectors.selectInviteVenue);
  const history = useHistory();

  const handleAccept = async () => {
    const api = api_v2(token);

    try {
      setLoading(true);
      // await api.splitTab(ticketId);
      const resp = await api.getTicket(ticketId);

      dispatch(AppActions.setVenue(venueId));
      dispatch(PayActions.setTicket(resp.data));

      setLoading(false);

      history.push(`/locations/${venueId}/tab`);
      dispatch(AppActions.setInvite(null));
    } catch (e) {
      console.log("get ticket info error: ", e.message);
      setLoading(false);
    }
  };

  const handleDismiss = () => {
    dispatch(AppActions.setInvite(null));
    history.push('/locations');
  };

  useEffect(() => {
    if (venueId && ticketId) {
      dispatch(AppActions.setInvite({ venueId, ticketId }));
    }
  }, []);

  return (
    <PageLayout title="Accept Invitation">
      <IonList className="ion-padding">
        <IonText className="center-flex-content mt-3x  mb-5x">
          <h2>
            You've been invited to join a tab at{' '}
            {inviteVenue ? `${inviteVenue.name}` : ``}
          </h2>
        </IonText>
        <div className="mt-3x mb-2x">
          <IonButton
            color="secondary"
            expand="block"
            fill="solid"
            onClick={handleAccept}
            disabled={loading}
          >
            Accept and Join Tab
          </IonButton>
        </div>
        <IonButton
          color="light"
          expand="block"
          fill="solid"
          onClick={handleDismiss}
          disabled={loading}
        >
          Dismiss
        </IonButton>
      </IonList>
    </PageLayout>
  );
}

export default InviteAcceptPage;
